import React from "react";
import { Select } from "antd";
import "./dropdownSelect.scss"; // Import custom styles

const DropdownSelect = ({
  label,
  options = [],
  placeholder,
  mode,
  value,
  onChange,
  filterOption,
  ...props
}) => {
  return (
    <div className="custom-dropdown-container">
      {label && <label className="custom-label">{label}</label>}
      <Select
        placeholder={placeholder}
        value={value} // Ensure controlled behavior
        onChange={onChange} // Handle changes correctly
        mode={mode}
        showSearch // Enable search
        filterOption={filterOption} // Use filter logic
        optionFilterProp="children" // Search based on option's labe
        className="custom-select"
        {...props}
      >
        {options.length > 0 ? (
          options.map((option) => (
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          ))
        ) : (
          <Select.Option value="" disabled>
            No options available
          </Select.Option>
        )}
      </Select>
    </div>
  );
};

export default DropdownSelect;
